import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'app-card',
  imports: [],
  templateUrl: './card.html',
  styleUrl: './card.scss',
})
export class Card {
  @Input() class = '';

  @HostBinding('class') get hostClasses(): string {
    return `flex bg-primary p-4 rounded-xl text-white ${this.class}`;
  }
}
